export class ActNowDictionaryItem {
    public id: number;
    public text: string;
}

export class KeyValueModel {
    public key: string;
    public value: string;
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/common/act-now-dictionary-item.ts